import { H5 } from "components/atoms/text";
import InputText from "components/atoms/input/Text";
import Btn from "components/atoms/buttons";
import FormImage from "components/templates/project/SideBar/Library/FormImage";

import useInput from "hooks/useInput";
import Scene from "types/Scene";
import useCreateScene from "apis/mutations/scene/useCreateScene";

interface Props {
  projectId: number;
  scenes: Scene[];
  position: number;
}

// 씬 생성
const ItemCreate = ({ projectId, scenes, position }: Props) => {
  const [sceneState, dispatch] = useInput({
    title: "",
    image: "",
  });

  // 씬 생성 api
  const createScene = useCreateScene({
    projectId,
    position,
    onSuccess: () => dispatch({ reset: true }),
  });

  const { image, title } = sceneState;

  // 씬 생성 이벤트
  const handleCreate = () => {
    if (!title || !image) return;
    createScene(sceneState);
  };

  return (
    <>
      <div className="flex gap-3">
        <FormImage
          image={image}
          name="scene"
          onDispatch={(option) => dispatch({ option })}
        />
        {!image && (
          <div className="flex flex-col justify-end pb-2">
            <p className="text-sm leading-7">
              먼저 이미지를
              <br />
              업로드 해주세요.
            </p>
          </div>
        )}
      </div>
      {image && (
        <div className="flex flex-col justify-end pb-2">
          <p className="mb-1 text-red leading-[16px] font-bold">
            마감재를 적용할 실명을 <br />
            정확하게 기입해 주세요.
          </p>
          <H5>Scene {scenes && scenes.length + 1}</H5>
          <div className="flex gap-2">
            <InputText
              small
              placeholder="실명을 기입해주세요."
              name="title"
              value={title}
              onChange={(event) => dispatch({ event })}
              shape="square"
              className={{
                input: "placeholder:text-xxs",
                container: "!px-2",
              }}
            />
            <Btn.Blue onClick={handleCreate} size="xsSmall" inActive={!title}>
              저장
            </Btn.Blue>
          </div>
        </div>
      )}
    </>
  );
};

export default ItemCreate;
